<!-- <p>rect-button-loader works!</p> -->
<!-- <div style="width: 100%;"> -->
<button [type]="type" [disabled]="disabled" [ngClass]="buttonClass" (click)="onClick($event)">
    <span *ngIf="isLoading" class="spinner-border" role="status" aria-hidden="true"></span>
    <ng-content *ngIf="!isLoading"></ng-content>
</button>
<!-- </div> -->